export const lvzMarkerRealTimeSelector = ({lvzMarkerRealTime}) => lvzMarkerRealTime